import { Logout } from '@mui/icons-material';
import { Grid, Typography, Sheet, Button, Box } from '@mui/joy';
import { getAuth } from 'firebase/auth';
import { Outlet } from 'react-router-dom';

const Dashboard = () => {
  return (
    <>
      <Sheet variant="soft">
        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection="row"
          p={2}
        >
          <Typography level="h1">Wirth Foundation</Typography>
          <Button
            variant="plain"
            startDecorator={<Logout />}
            onClick={() => getAuth().signOut()}
          >
            log out
          </Button>
        </Box>
      </Sheet>
      <Grid container justifyContent="center" sx={{ my: 1, pb: 3 }}>
        <Grid xs={12} md={10} p={1}>
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
